import React from "react";
import "./App.css";
import Rutas from "./components/Rutas";

function App() {
  return (
    <>
      <section className="container">
        <Rutas />
      </section>
    </>
  );
}

export default App;
